import React from 'react';

import type {LogoIconProps} from '../types';
import {colourMap, sizesMap} from '../utils/iconProperties';

/* eslint-disable complexity */
const GoogleIcon = ({
  size = 'small',
  colour = 'textPrimary',
  alt,
  fullColour,
}: LogoIconProps): JSX.Element => {
  const fill = fullColour ? null : colourMap[colour];

  return (
    <svg
      aria-hidden={!alt ? true : undefined}
      aria-label={alt}
      role={alt ? 'img' : undefined}
      width={sizesMap[size]}
      height={sizesMap[size]}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={fullColour ? 'full-colour' : undefined}
    >
      <path
        fill={fill || '#4285F4'}
        d='m22.6 12.3-.2-2.3H12v4.3h6a5 5 0 0 1-2.3 3.3v2.7h3.6c2-1.9 3.3-4.7 3.3-8z'
      />
      <path
        fill={fill || '#34A853'}
        d='M12 23c3 0 5.5-1 7.3-2.7l-3.6-2.7c-1 .6-2.2 1-3.7 1-2.9 0-5.3-1.9-6.2-4.5H2.2v2.8A11 11 0 0 0 12 23z'
      />
      <path
        fill={fill || '#FBBC05'}
        d='M5.8 14a6.6 6.6 0 0 1 0-4V7H2.2a10.9 10.9 0 0 0 0 10L5 14.6l.8-.6z'
      />
      <path
        fill={fill || '#EA4335'}
        d='M12 5.4A6 6 0 0 1 16.2 7L19.4 4A11 11 0 0 0 2.2 7l3.6 2.8A6.6 6.6 0 0 1 12 5.4z'
      />
    </svg>
  );
};

export default GoogleIcon;
